import React, { Component } from "react"
import { Button, FormControl, Modal, OverlayTrigger, Tooltip } from "react-bootstrap"
import Select from "react-select"
import states from "src/utilities/States/states"
import EmployeeDataTypes from "../../../../../Types/EmployeeTypes"
import ReferenceTypes from "../../../../../Types/ReferenceTypes"
import "./EditAddress.css"

interface MailingAddressProps {
    employee: EmployeeDataTypes
    copy: EmployeeDataTypes
    appendParams: Function
    reference: ReferenceTypes
    toggleEditAddress: Function
}

type PhysicalAddressTypes = {
    isDirty: boolean
    eventType: string
}

class MailingAddress extends Component<MailingAddressProps, PhysicalAddressTypes> {

    state = {
        isDirty: false,
        eventType: ""
    }

    setEventType = (type: string) => {
        this.setState({ eventType: type })
    }

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        let employee = this.props.employee
        let eventType = this.state.eventType
        let eventTypes = Object.keys(employee)
        let temp: any = employee
        for (let i = 0; i < eventTypes.length; i++) {
            if (eventType === eventTypes[i]) {
                temp[eventTypes[i]] = input
                let param: object = { [eventTypes[i]]: input }
                this.props.appendParams([param])
            }
        }
        this.checkIfDirty()
    }


    checkIfDirty = () => {
        let employee = this.props.employee
        let copy = this.props.copy
        let a = JSON.stringify({ a: employee.MailingAddress1, b: employee.MailingAddress2, c: employee.MailingCity, d: employee.MailingState, e: employee.MailingZipCode })
        let b = JSON.stringify({ a: copy.MailingAddress1, b: copy.MailingAddress2, c: copy.MailingCity, d: copy.MailingState, e: copy.MailingZipCode })
        if (a !== b) {
            this.setState({ isDirty: true })
        } else {
            this.setState({ isDirty: false })
        }
    }

    save = () => {
        this.props.toggleEditAddress("editMailingAddress")
    }

    clear = () => {
        this.props.appendParams([{ MailingAddress1: null }, { MailingAddress2: null }, { MailingCity: null }, { MailingState: null }, { MailingZipCode: null }])
        this.checkIfDirty()
    }

    undo = () => {
        this.props.appendParams([{ MailingAddress1: this.props.copy.MailingAddress1 }, { MailingAddress2: this.props.copy.MailingAddress2 }, { MailingCity: this.props.copy.MailingCity }, { MailingState: this.props.copy.MailingState }, { MailingZipCode: this.props.copy.MailingZipCode }])
        this.props.toggleEditAddress("editMailingAddress")
    }

    render() {

        const ClearAllTooltip = (
            <Tooltip id="uac-tool-tip">
                Clear all fields
            </Tooltip>
        )


        return (
            <div className="MailingAddress">
                <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="EditAddressModalHeader">
                            <p>Mailing Address</p>
                            <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={ClearAllTooltip}>
                                <span id="edit-address-clear-btn" className="material-icons" onClick={() => this.clear()}>clear_all</span>
                            </OverlayTrigger>                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="UACAddressR1">
                            {this.props.employee.MailingAddress1 && <div id="uac-filled-field"><p>Address Line 1<span className="material-icons">done</span></p></div>}
                            {!this.props.employee.MailingAddress1 && <div id="uac-missing-field"><p>Address Line 1<span className="material-icons">warning</span></p></div>}
                            <FormControl
                                onFocus={() => this.setEventType("MailingAddress1")}
                                placeholder={this.props.employee.MailingAddress1 || "*NA*"}
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.props.employee.MailingAddress1 || ""}
                            />
                            <div id="uac-filled-field"><p>Address Line 2</p></div>
                            <FormControl
                                onFocus={() => this.setEventType("MailingAddress2")}
                                placeholder={this.props.employee.MailingAddress2 || "*NA*"}
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.props.employee.MailingAddress2 || ""}
                            />
                        </div>
                        <div className="UACAddressR2">
                            <div className="UACAddressR2Column">
                                {this.props.employee.MailingCity && <div id="uac-filled-field"><p>City<span className="material-icons">done</span></p></div>}
                                {!this.props.employee.MailingCity && <div id="uac-missing-field"><p>City<span className="material-icons">warning</span></p></div>}
                                <FormControl
                                    onFocus={() => this.setEventType("MailingCity")}
                                    placeholder={this.props.employee.MailingCity || "*NA*"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.props.employee.MailingCity || ""}
                                />
                            </div>
                            <div className="UACAddressR2Column" id="uac-address-r2-middle-column">
                                {this.props.employee.MailingState && <div id="uac-filled-field"><p>State<span className="material-icons">done</span></p></div>}
                                {!this.props.employee.MailingState && <div id="uac-missing-field"><p>State<span className="material-icons">warning</span></p></div>}
                                {this.props.reference.allStates &&
                                    <Select
                                        //@ts-ignore
                                        value={{ label: this.props.employee.MailingState || "*NA*" }}
                                        options={states.map((s: any) => ({ value: s.StateID, label: s.StateName, code: s.StateCode }))}
                                        onChange={(item: any) => {
                                            this.props.appendParams([{ MailingState: item.code }])
                                            this.checkIfDirty()
                                        }}
                                        // menuPlacement="top"
                                        maxMenuHeight={300}
                                    />}
                            </div>
                            <div className="UACAddressR2Column">
                                {this.props.employee.MailingZipCode && <div id="uac-filled-field"><p>Zip Code<span className="material-icons">done</span></p></div>}
                                {!this.props.employee.MailingZipCode && <div id="uac-missing-field"><p>Zip Code<span className="material-icons">warning</span></p></div>}
                                <FormControl
                                    onFocus={() => this.setEventType("MailingZipCode")}
                                    placeholder={this.props.employee.MailingZipCode || "*NA*"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.props.employee.MailingZipCode || ""}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="EditAddressModalFooter">
                            <Button variant="secondary" onClick={() => this.undo()}>Cancel</Button>
                            <Button variant="primary" disabled={!this.state.isDirty} onClick={() => this.save()}>Ok</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default MailingAddress